import { mapGetters } from 'vuex';
import {
  checkPermission,
  checkAllPermissions,
  checkAnyPermission,
} from '@/utils/permissionUtils';

const permissionMixin = {
  computed: {
    ...mapGetters(['listPermission']),
  },
  methods: {
    checkPermission(condition) {
      return checkPermission(this.listPermission, condition);
    },

    checkAllPermissions(conditions) {
      return checkAllPermissions(this.listPermission, conditions);
    },

    checkPermissions(conditions) {
      return checkAnyPermission(this.listPermission, conditions);
    },
  },
};

export default permissionMixin;
